const BLOCKED_BLOCKS =
  /<(script|iframe|object|embed|style)\b[^>]*>[\s\S]*?<\/\1>/gi;
const BLOCKED_TAGS = /<\/?(script|iframe|object|embed|link|meta|base|form|input|textarea|button|style)[^>]*>/gi;
const EVENT_ATTRS = /\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi;
const DANGEROUS_URL = /\s(href|src)\s*=\s*(['"]?)\s*javascript:/gi;

export function sanitizeHtml(html: string): string {
  return String(html || '')
    .replace(BLOCKED_BLOCKS, '')
    .replace(BLOCKED_TAGS, '')
    .replace(EVENT_ATTRS, '')
    .replace(DANGEROUS_URL, ' $1=$2');
}

export function isValidGaId(value: string): boolean {
  return /^G-[A-Z0-9]+$/i.test(String(value || '').trim());
}
